import { FAVOURITES_CATEGORY, MOST_USED_CATEGORY, libraryCategoryLabel } from './libraryPrefs';

interface LibraryCategoryTabsProps {
  categories: string[];
  selected: string;
  onSelect: (category: string) => void;
}

/** The object library's category row, virtual tabs (Favourites, Most used) included. */
export function LibraryCategoryTabs({ categories, selected, onSelect }: LibraryCategoryTabsProps) {
  return (
    <div className="flex flex-wrap gap-1 mb-2" role="group" aria-label="Library categories">
      {categories.map((cat) => (
        <button
          key={cat}
          type="button"
          onClick={() => onSelect(cat)}
          aria-pressed={selected === cat}
          className={`px-2 py-0.5 text-xs rounded ${
            selected === cat
              ? 'bg-primary-100 text-primary-700 font-medium'
              : 'text-gray-500 hover:bg-gray-100'
          }`}
          data-testid={
            cat === FAVOURITES_CATEGORY
              ? 'lib-cat-favourites'
              : cat === MOST_USED_CATEGORY
                ? 'lib-cat-most-used'
                : `lib-cat-${cat}`
          }
        >
          {libraryCategoryLabel(cat)}
        </button>
      ))}
    </div>
  );
}
